import React, { useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  makeStyles,
  Button,
  Paper,
  Grid,
  Collapse,
  CardActions,
  IconButton,
  Box,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    background: theme.palette.type === "dark" ? "#000" : "#f5f5f5",
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(3),
    textAlign: "center",
    color: theme.palette.type === "dark" ? "#fff" : "#000",
  },
  card: {
    marginBottom: theme.spacing(3),
    transition: "box-shadow 0.3s",
    backgroundColor: theme.palette.type === "dark" ? "#121212" : "#fafafa",
    "&:hover": {
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    },
  },
  cardMedia: {
    height: 200,
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  cardTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.type === "dark" ? "#fff" : "#777",
  },
  cardDescription: {
    fontSize: "1rem",
    marginBottom: theme.spacing(2),
    textAlign: "justify",
    color: theme.palette.type === "dark" ? "#aaa" : "#777",
  },
  learnMoreButton: {
    backgroundColor: "#8601af",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#8601af",
    },
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  cardFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

const Services = () => {
  const classes = useStyles();

  const services = [
    {
      title: "Group Tutorials",
      description:
        "Our group sessions consist of 10 learners or more per group. This is one of our most popular services available. It’s made a big difference for many of our customers, and is provided with the highest level of excellence. With this service, we ensure all details are simple, seamless and handled in a timely manner. Whenever you work with NgeMbalenhle Tutoring Services, you can trust that you’re in great hands.",
      image: "/assets/images/group_tutorial.webp",
    },
    {
      title: "One on One Tutorials",
      description:
        "Frequently utilized by most of our customers, this service has been essential to success on many occasions. When it comes to all of our services, you can count on us to take care of your every need. We pride ourselves on exceptional customer service, and guarantee you’ll love working with our team. Sessions are conducted in schools for individuals to have private sessions with the tutor. Let us know how we can assist you today.",
      image: "/assets/images/one_on_one_tutorial.webp",
    },
    {
      title: "Home Tutorials",
      description:
        "This is one of our most popular services available. It’s made a big difference for many of our customers, and is provided with the greatest level of excellence. With this service, we ensure all details are simple, assist with homework’s and students tend to be more cooperative and more comfortable when learning from home. Whenever you work with NgeMbalenhle Tutoring Services, you can trust that you’re in great hands.",
      image: "/assets/images/home_tutorial.webp",
    },
    {
      title: "Virtual Tutorials",
      description:
        "Online tutorig that can take place from different locations, provided that the learner and the tutor communicate by means of an application (either zoom or any other application). This is provided for one on one and group sessions.",
      image: "/assets/images/virtual_tutorial.webp",
    },
    // Add more services here...
  ];

  const [expanded, setExpanded] = useState(services.map(() => false));

  const handleExpandClick = (index) => {
    const newExpanded = [...expanded];
    newExpanded[index] = !newExpanded[index];
    setExpanded(newExpanded);
  };

  return (
    <Paper className={classes.container} elevation={3}>
      <Typography variant="h4" className={classes.title}>
        Our Services
      </Typography>
      <Grid container spacing={3}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card className={classes.card}>
              <CardMedia
                className={classes.cardMedia}
                image={service.image}
                title={service.title}
              />
              <CardContent>
                <Typography variant="h6" className={classes.cardTitle}>
                  {service.title}
                </Typography>
                <Typography variant="body1" className={classes.cardDescription}>
                  {service.description.substring(0, 100)}...
                </Typography>
              </CardContent>
              <CardActions disableSpacing className={classes.cardFooter}>
                <Button
                  variant="contained"
                  className={classes.learnMoreButton}
                  onClick={() => handleExpandClick(index)}
                >
                  Learn More
                </Button>
                <Box>
                  <IconButton
                    className={
                      expanded[index] ? classes.expandOpen : classes.expand
                    }
                    onClick={() => handleExpandClick(index)}
                    aria-expanded={expanded[index]}
                    aria-label="show more"
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                </Box>
              </CardActions>
              <Collapse in={expanded[index]}>
                <CardContent>
                  <Typography
                    variant="body2"
                    className={classes.cardDescription}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default Services;
